import { required, decimal } from 'vuelidate/lib/validators'
export default {
    required,
    $each: {
        id: {},
        name: {},
        picture: {},
        quadrant: {},
        occupation: {},
        actual_x: {},
        actual_y: {},
        newQuadrant: {},
        x: {
            required,
            decimal,
        },
        y: {
            required,
            decimal,
        },
    },
}
